export const FETCH_TEAM_LIST_END = "FETCH_TEAM_LIST_END";
export const FETCH_TEAM_START = "FETCH_TEAM_START";
export const SET_TEAM = "SET_TEAM";
export const TOGGLE_MANAGE_COMPANY_EDIT_STATE = "TOGGLE_MANAGE_COMPANY_EDIT_STATE";
export const UPDATE_MANAGE_COMPANY_FIELD = "UPDATE_MANAGE_COMPANY_FIELD";
export const LOAD_TEAM_TO_EDIT = "LOAD_TEAM_TO_EDIT";
export const TOGGLE_EDIT_TEAM_DIALOG = "TOGGLE_EDIT_TEAM_DIALOG";
export const RESET_DEFAULT_NEW_TEAM = "RESET_DEFAULT_NEW_TEAM";
export const RESET_DEFAULT_NEW_TEAM_LIST = "RESET_DEFAULT_NEW_TEAM_LIST";
export const TOGGLE_NEW_TEAM_DIALOG = "TOGGLE_NEW_TEAM_DIALOG";
export const UPDATE_TEAM_FIELD = "UPDATE_TEAM_FIELD";
export const RESET_DEFAULT_TEAM_TO_EDIT = "RESET_DEFAULT_TEAM_TO_EDIT";
export const UPDATE_ADD_TEAM_FIELD = "UPDATE_ADD_TEAM_FIELD";
